import "./ServiceList.css";
import React from "react";

export const ServiceList = () => {
    return (
        <div id="services_dropdown">
            <ul id="services">
                <li>Chirurgia stomatologiczna</li>
                <li>Diagnostyka</li>
                <li>Endodoncja</li>
                <li>Okluzja</li>
                <li>Periodontologia</li>
                <li>Profilaktyka</li>
                <li>Protetyka</li>
                <li>Stomatologia dziecięca</li>
                <li>Stomatologia estetyczna</li>
                <li>Stomatologia zachowawcza</li>
            </ul>
        </div>
    );
};
